import React from 'react';
import { useDateTimeFormatter } from '../../../../../../hooks/useDateTimeFormat';
import { getRepeatScheduleLabel } from '../../../../DataTableAdvancedElements/DataTableQuickReports/utils/QuickReports.utils';
import { QueryModel, SortModel } from '../../../../utils/DataTableQueryProvider/DataTableQuery.types';
import { OnQuickReportsChanged } from '../../../../utils/DataTableTypes';
import { useIntlUds } from '../../../../../../translations/UdsIntlProvider';

interface Props<Q extends QueryModel, S extends SortModel> {
  report: OnQuickReportsChanged<Q, S>;
}

export const EditScheduleDesc = <Q extends QueryModel, S extends SortModel>({ report }: Props<Q, S>) => {
  const { dateTimeFormatter } = useDateTimeFormatter();
  const { format, intl } = useIntlUds();

  if (!report.schedule) return null;

  return (
    <div>
      {format(intl.DataTable.QuickViews.Panel.repeats, {
        timeInterval: getRepeatScheduleLabel(report.schedule.timeInterval)
      })}
      <br />
      {!!report.schedule.nextTimestamp &&
        format(intl.DataTable.QuickViews.Panel.next, {
          date: dateTimeFormatter(report.schedule.nextTimestamp, { long: true, time: true, utc: true })
        })}
    </div>
  );
};
